export default __webpack_public_path__ + "static/media/DSC_7557.ed9fd2cb.jpg";